import { render, staticRenderFns } from "./WABAChannelDetail.vue?vue&type=template&id=092cbf01&scoped=true"
import script from "./WABAChannelDetail.vue?vue&type=script&lang=js"
export * from "./WABAChannelDetail.vue?vue&type=script&lang=js"
import style0 from "./WABAChannelDetail.vue?vue&type=style&index=0&id=092cbf01&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "092cbf01",
  null
  
)

export default component.exports